<template>
  <el-container class="ds-custom-query">
    <el-aside width="20%">
      <el-tree :data="queryFieldData" :props="defaultProps" default-expand-all :expand-on-click-node="false">
        <template v-slot:default="{node,data}">
          <div class="ds-field-tree-custom-node" @dblclick="pushQueryItem(node,data)">
            <DsfCustomQueryField :node="node" :data="data" @drag="fieldDragHandler" :drag-proxy-append-to="'.ds-custom-query'">
              <slot name="field-node"></slot>
            </DsfCustomQueryField>
          </div>
        </template>
      </el-tree>
    </el-aside>
    <el-main ref="main">
      <template v-if="isEmptyItems">
        <div style="display:flex;height:100%;align-items: center;justify-content: center;">请双击或拖拽左侧相关字段到此处</div>
      </template>
      <DsfCustomQueryLogic ref="logic" v-else :data="queryLogicData" :drag-proxy-append-to="'.ds-custom-query'"></DsfCustomQueryLogic>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "DsfCustomQuery",
  provide(){
    return {
      $queryVm:this
    }
  },
  props: {
    queryLogicData: {
      type: Object,
      default() {
        return {
          logic: "and",
          items: []
        };
      }
    },
    queryFieldData: {
      type: Array,
      default() {
        return [
          {
            label: "用户表",
            tableName: "ds_user",
            type: "table",
            children: [
              {
                label: "字段1",
                field: "field1",
                type: "field"
              },
              {
                label: "字段2",
                field: "field2",
                type: "field"
              },
              {
                label: "字段3",
                field: "field3",
                type: "field"
              },
              {
                label: "字段4",
                field: "field4",
                type: "field"
              }
            ]
          }
        ];
      }
    }
  },
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },
  computed:{
    isEmptyItems(){
      if(this?.queryLogicData?.items?.length){
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.initDrop();
  },
  methods: {
    initDrop() {
      let _this = this;
      $(this.$refs.main.$el).droppable({
        accept: function (drag) {
          if (drag.hasClass("ds-field-tree-node")) {
            return true;
          }
          return false;
        },
        tolerance: "pointer",
        hoverClass: "ds-cutsom-query-drop-hover",
        drop($evt, ui) {
          let fromNode = ui.draggable.get(0).__vue__;
          let data = fromNode.data;
          let node=fromNode.node;
          _this.queryLogicData.items.push({
            field: data.field,
            operator: "eq",
            table: _this.getTableName(node, data),
            value: null
          });
          fromNode.dropSuccess = true;
        }
      });
    },
    pushQueryItem(node, data) {
      if (data.type == "field") {
        this.queryLogicData.items.push({
          field: data.field,
          operator: "eq",
          table: this.getTableName(node, data),
          value: null
        });
      }
    },
    getTableName(node, data) {
      let curNode = node;
      if (node.table) {
        return node.table;
      }
      while (true) {
        if (!curNode || curNode.data.type == "table") {
          break;
        } else {
          curNode = curNode.parent;
        }
      }
      if (curNode && curNode.data.type == "table") {
        return curNode.data.tableName;
      }
      return "";
    },
    fieldDragHandler(arg){
      if(this?.$refs?.logic){
        this.$refs.logic.dragAutoScroll({
          top: arg.event.clientY,
          left: arg.event.clientX
        })
      }
    }
  }
};
</script>

<style>
</style>